import api from '..'

const requests = {
    fetchInterests: async (search, sortKey, sortType, pageSize, page) => {
        var response = await api.get(`/wellful/Interest/`, {
            params: {
                search,
                sortKey,
                sortType,
                pageSize,
                page
            }
        })

        return response.data
    },
    fetchInterest: async (id) => {
        var response = await api.get(`/wellful/Interest/${id}`)
        return response.data
    }
}

export default requests
